import styled from 'styled-components';
import {Space} from 'antd';

const StyledExpensesTab = styled(Space)`
  padding: 0 24px;
  position: relative;
  width: 100%;

  .grouped-row {
    background-color: ${props => props.theme.colors.neutral_2};
    color: ${props => props.theme.colors.neutral_7};

    .amount {
      color: ${props => props.theme.colors.neutral_10};
      font-weight: 700;
    }
  }

  .ghost-table-cell {
    .ant-tag {
      margin: 0;
    }
  }
`;

const StyledExpensesTabIcon = styled.span`
  display: inline-flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  svg {
    height: 24px;
    width: 24px;
  }
`;

const StyledExpensesTabActionsSpace = styled(Space)`
  & > .ant-space-item {
    align-items: center;
    display: flex;
  }

  button {
    align-items: center;
    display: flex;
    justify-content: center;
    svg {
      height: 14px;
      width: 14px;
      path {
        fill: ${props => props.theme.colors.neutral_10};
      }
    }
  }
`;

export {
  StyledExpensesTab,
  StyledExpensesTabIcon,
  StyledExpensesTabActionsSpace
}
